import RightDrawer from "@common/components/RightDrawer";
import Grid from '@mui/material/Grid2';
import { Stack } from "@mui/material";
import { ArchivedDevice, ArchivedTimeValue } from "@services/devices/types";
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import ArchivedDeviceInformations from "./ArchivedDeviceInformations";
import ArchivedDeviceFilters from "./ArchivedDeviceFilters";
import Button from "@common/components/Button";

type ArchivedDeviceDrawerProps = {
  openDrawer: boolean;
  setOpenDrawer: Dispatch<SetStateAction<boolean>>;
  isFilterDrawer?: boolean;
  device?: ArchivedDevice;
  timeFilter?: number;
  setTimeFilter?: Dispatch<SetStateAction<number>>;
  counter?: number;
  setCounter?: Dispatch<SetStateAction<number>>;
  setPage?: Dispatch<SetStateAction<number>>;
};

const ArchivedDeviceDrawer = (props: ArchivedDeviceDrawerProps) => {
  const { t } = useTranslation();
  const {
    openDrawer,
    setOpenDrawer,
    isFilterDrawer,
    device,
    timeFilter,
    setTimeFilter,
    counter,
    setCounter,
    setPage,
  } = props;
  const [tmptimeFilter, setTmpTimeFilter] = useState<number>(
    timeFilter ?? ArchivedTimeValue.All
  );

  const handleSearch = useCallback(() => {
    setTimeFilter && setTimeFilter(tmptimeFilter);
    if (tmptimeFilter !== ArchivedTimeValue.All) {
      setCounter && setCounter(1);
    } else {
      setCounter && setCounter(0);
    }

    setPage && setPage(1);
    setOpenDrawer(false);
  }, [tmptimeFilter]);
  
  useEffect(() => {
    setTmpTimeFilter(timeFilter ?? ArchivedTimeValue.All);
  }, [timeFilter]);

  return (
    <RightDrawer
      open={openDrawer}
      onClose={handleSearch}
      title={
        isFilterDrawer
          ? t("Add filters ({{ COUNTER }})", { COUNTER: counter })
          : t("Archive Information")
      }
      closeButton={
        <>
          {isFilterDrawer ? (
            <Grid
              sx={(theme) => ({
                "&>.MuiButton-root": { marginRight: theme.spacing(1) },
              })}>
              <Button color="white" onClick={handleSearch}>
                Filter
              </Button>
              <Button
                color="greyed"
                variant="outlined"
                onClick={() => {
                  setTmpTimeFilter(ArchivedTimeValue.All);
                  setTimeFilter && setTimeFilter(ArchivedTimeValue.All);
                  setCounter && setCounter(0);
                  setPage && setPage(1);
                }}
              >
                Clear
              </Button>
              <Button
                color="greyed"
                variant="outlined"
                onClick={() => {
                  setTmpTimeFilter(timeFilter ?? ArchivedTimeValue.All);
                  setOpenDrawer(false);
                }}
              >
                Cancel
              </Button>
            </Grid>
          ) : (
            <Button
              color="greyed"
              variant="outlined"
              onClick={() => {
                setOpenDrawer(false);
              }}
            >
              Close
            </Button>
          )}
        </>
      }
    >
      <Stack sx={{ px: 2 }}>
        {isFilterDrawer ? (
          <ArchivedDeviceFilters
            timeFilter={tmptimeFilter}
            setTimeFilter={setTmpTimeFilter}
          />
        ) : (
          <ArchivedDeviceInformations device={device} />
        )}
      </Stack>
    </RightDrawer>
  );
};

export default ArchivedDeviceDrawer;
